/* Velum — scroll reveal
   Horizon's flexible section/block schema (this theme version) has no
   "custom CSS class" setting on sections or blocks, so section wrappers
   can't be tagged with .velum-reveal from the theme editor. Instead this
   script marks Shopify's own per-section wrapper divs (.shopify-section,
   rendered automatically for every section on the page) as reveal targets,
   then observes them. Content stays visible by default if JS fails to run,
   since .velum-reveal only gets its hidden starting state once this script
   adds the class immediately before observing. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var wrappers = document.querySelectorAll('#MainContent .shopify-section');
  if (!wrappers.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    }
  );

  wrappers.forEach(function (el) {
    el.classList.add('velum-reveal');
    observer.observe(el);
  });
})();
